import React from 'react';
import { Mail, Phone, MapPin, Download } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = 'https://customer-assets.emergentagent.com/job_744874e0-0fe3-4cd2-a918-10824da88281/artifacts/7oog39co_Sperah_Full_Combined_Presentation_Final.pptx';
    link.download = 'Sperah_Project_Management_Presentation.pptx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="text-3xl font-black mb-4">
              <span className="text-[#A63446]">SPERAH</span>
            </h3>
            <p className="text-gray-400 leading-relaxed mb-6">
              Excellence in project planning, development, and execution. Delivering exceptional results through intelligent methodologies.
            </p>
            <button
              onClick={handleDownload}
              className="inline-flex items-center gap-2 text-[#A63446] hover:text-[#C14758] transition-colors font-semibold"
            >
              <Download className="h-5 w-5" />
              Download PPTX
            </button>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Quick Links</h4>
            <ul className="space-y-3">
              {['Home', 'About', 'Services', 'Methodology', 'Contact'].map((link) => (
                <li key={link}>
                  <button
                    onClick={() => scrollToSection(link.toLowerCase())}
                    className="text-gray-400 hover:text-[#A63446] transition-colors"
                  >
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Services</h4>
            <ul className="space-y-3 text-gray-400">
              <li>Project Planning</li>
              <li>Team Management</li>
              <li>Process Development</li>
              <li>Quality Assurance</li>
              <li>Change Management</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-[#A63446] flex-shrink-0 mt-1" />
                <a href="mailto:info@sperah.com" className="text-gray-400 hover:text-[#A63446] transition-colors">
                  info@sperah.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-[#A63446] flex-shrink-0 mt-1" />
                <a href="tel:+15551234567" className="text-gray-400 hover:text-[#A63446] transition-colors">
                  +1 (555) 123-4567
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[#A63446] flex-shrink-0 mt-1" />
                <span className="text-gray-400">Business District, Global City</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} Sperah Project Management. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm text-gray-400">
              <button className="hover:text-[#A63446] transition-colors">Privacy Policy</button>
              <button className="hover:text-[#A63446] transition-colors">Terms of Service</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;